const frontendURL = '/cat/objectexamination/';
const backendURL = '/api/akt_dvk/objectexamination/';
const name = 'Об\' єкт обстеження';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
